<template>

<div class="home-content">
  <div class="fold-container">
    <div class="container hero-container">
      <div class="first-content">
        <div class="intro-tekst">
          <slot name="intro-tekst"></slot>
        </div>
      </div>

    <div class="case-hightlight-img">
      <div class="intro-animation">
        <div class="animation">
          <slot name="intro-animation"></slot>
        </div>
      </div>
    </div>
  </div>
  <div class="home-bg-color"></div>
  </div>

</div>
</template>

<script>

export default {
  name: 'halfBanner',
}
</script>

<style lang="scss" scoped>

.fold-container .home-bg-color{
  opacity: 0;
  animation-fill-mode: forwards;
  animation-delay: 1.8s;
}

.home-bg-color{
  background-image: url(../../assets/Folded_Paper_contact_background.jpg);
  background-repeat: no-repeat;
  background-size: cover;
}
.intro-tekst{
  z-index: 1;
  a{
    text-decoration: underline;
  }
}

</style>